module.exports = __webpack_public_path__ + "img/logo_i.01f08599.png";